import { render } from "./BookmarksView.vue?vue&type=template&id=1ce07476&scoped=true"
import script from "./BookmarksView.vue?vue&type=script&lang=js"
export * from "./BookmarksView.vue?vue&type=script&lang=js"

import "./BookmarksView.vue?vue&type=style&index=0&id=1ce07476&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce07476"]])

export default __exports__